module.exports = __webpack_public_path__ + "img/text.cc9fb7a7.svg";